import OperatorFAQHelperPage from "../../../Components/Info/FAQ/Index";

const OperatorFAQConenctingOfficalPage = () => {
  return <OperatorFAQHelperPage />;
};

export default OperatorFAQConenctingOfficalPage;
